export default __webpack_public_path__ + "static/media/annisa-ayat-1.6db1aca1.mp3";